import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Wind2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m511.05 179.43c-26.04 0-50.68 11.43-67.62 31.36l22.86 19.43c11.23-13.21 27.54-20.79 44.76-20.79 32.51 0 58.95 26.71 58.95 59.53s-27 61.61-58.95 61.61h-211.05c-16.57 0-30 13.43-30 30h241.05c23.77 0 46.19-9.77 63.14-27.5 16.65-17.42 25.81-40.19 25.81-64.1 0-49.37-39.9-89.53-88.95-89.53z' />
    <path d='m421.05 419.43h-241.05c0 16.57 13.43 30 30 30h211.05c31.96 0 58.95 28.21 58.95 61.61s-26.45 59.53-58.95 59.53c-17.22 0-33.53-7.58-44.76-20.79l-22.86 19.43c16.94 19.93 41.58 31.36 67.62 31.36 49.05 0 88.95-40.16 88.95-89.53 0-23.91-9.17-46.68-25.81-64.1-16.95-17.74-39.37-27.5-63.14-27.5z' />
  </IconBase>
));

Wind2.displayName = 'Wind2';

export default Wind2;
